export default {
  generic_error: 'Noget gik galt',
  address_not_found:
    'Beklager, vi kunne ikke finde den adresse. Prøv igen ved først at indtaste vejnavnet i adressefeltet.',
  internal_error:
    'Der opstod desværre et uventet problem med din ordre, og vores tekniske team arbejder allerede på det 🛠️.',
};
